import * as Dtos from '@/api/dtos';
import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';

const getData = (response?: SWRResponse<Dtos.GetEarlyBirdRegistrationPriceResponse, Dtos.GetEarlyBirdRegistrationPriceResponse>) =>
    response?.data?.price;

const getError = (response?: SWRResponse<Dtos.GetEarlyBirdRegistrationPriceResponse, Dtos.GetEarlyBirdRegistrationPriceResponse>) =>
    (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<Dtos.GetEarlyBirdRegistrationPriceResponse, Dtos.GetEarlyBirdRegistrationPriceResponse>) => ({
    price: response?.data?.price,
    priceLoaded: response?.data?.price !== undefined,
});

export const useEarlyBirdPrice = (configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return () => new Dtos.GetEarlyBirdRegistrationPrice();
    }, []);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
};

export default useEarlyBirdPrice;
